import { Box, Typography } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput } from 'src/api/process-module';

interface DividerFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const DividerField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: DividerFieldProps) => {
  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Typography variant="body2" color="text.secondary">
          Divider fields don't require any configuration.
        </Typography>
      </Box>
    </>
  );
};
